export const DOCUMENT_TYPES = {
    DNI_FRONT: 'dni_front',
    DNI_BACK: 'dni_back',
    PASSPORT_FRONT: 'passport_front',
    PASSPORT_BACK: 'passport_back',
    NIE_FRONT: 'nie_front',
    NIE_BACK: 'nie_back',
    PERMIT_FRONT: 'permit_front',
    PERMIT_BACK: 'permit_back',
    DAAL: 'daal',
    RECIBO_TRANSFERENCIA: 'recibo',
    TRANSFER_CERTIFICATE: 'transfer_certificate',
    OTE: 'ote',
    OPEN_CREDIT: 'open_credit',
    DAAL_NOMINA_PENSION: 'daal_nomina_pension',
    PERMIT_NOMINA: 'permit_nomina',
    PERMIT_PENSION: 'permit_pension',
    REFUGEE: 'refugee',
};
export const IDENTITY_DOCUMENTS = [
    DOCUMENT_TYPES.DNI_FRONT,
    DOCUMENT_TYPES.DNI_BACK,
    DOCUMENT_TYPES.PASSPORT_FRONT,
    DOCUMENT_TYPES.PASSPORT_BACK,
    DOCUMENT_TYPES.NIE_FRONT,
    DOCUMENT_TYPES.NIE_BACK,
    DOCUMENT_TYPES.PERMIT_FRONT,
    DOCUMENT_TYPES.PERMIT_BACK,
];

export const DOCUMENTS_TO_BE_CAPTURED = [
    DOCUMENT_TYPES.DNI_FRONT,
    DOCUMENT_TYPES.DNI_BACK,
    DOCUMENT_TYPES.PASSPORT_FRONT,
    DOCUMENT_TYPES.PASSPORT_BACK,
    DOCUMENT_TYPES.PERMIT_FRONT,
    DOCUMENT_TYPES.PERMIT_BACK,
];

export const EXTRA_DOCUMENTS = [
    DOCUMENT_TYPES.DAAL,
    DOCUMENT_TYPES.RECIBO_TRANSFERENCIA,
    DOCUMENT_TYPES.TRANSFER_CERTIFICATE,
    DOCUMENT_TYPES.OTE,
    DOCUMENT_TYPES.OPEN_CREDIT,
    DOCUMENT_TYPES.DAAL_NOMINA_PENSION,
];

export const documentPhotoInstructions = [
    { icon: 'icon-valid-document', text: 'contentStepsTitles-flatSurfaceInfo' },
    { icon: 'icon-brightness-photo', text: 'contentStepsTitles-sharpnessInfo' },
    { icon: 'icon-cut-photo', text: 'contentStepsTitles-NaturalLightInfo' },
];
